import React, { useState } from 'react';
import './CancellationModal.css';

const CancellationModal = ({ booking, onClose, onConfirm, cancellationDeadline, refundProcessingDays }) => {
  const [confirming, setConfirming] = useState(false);

  const handleConfirm = async () => {
    setConfirming(true);
    try {
      await onConfirm();
    } catch (error) {
      console.error('Cancellation error:', error);
    } finally {
      setConfirming(false);
    }
  };

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return { date: 'N/A', time: 'N/A' };
    try {
      const date = new Date(dateTimeString);
      return {
        date: date.toLocaleDateString('en-US', { 
          weekday: 'short', 
          month: 'short', 
          day: 'numeric',
          year: 'numeric'
        }),
        time: date.toLocaleTimeString('en-US', { 
          hour: '2-digit', 
          minute: '2-digit',
          hour12: true
        })
      };
    } catch (e) {
      return { date: dateTimeString, time: 'N/A' };
    }
  };

  const dateTime = formatDateTime(booking?.showDateTime);
  const seatList = booking?.seatsLabel || (Array.isArray(booking?.seats) ? booking.seats.join(', ') : '');

  return (
    <div className="cancellation-modal-overlay" onClick={onClose}>
      <div className="cancellation-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cancellation-modal-header">
          <h3>Cancel Booking</h3>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="cancellation-modal-body">
          <div className="booking-summary">
            <h4>Booking Details</h4>
            <div className="summary-item">
              <span className="label">Movie:</span>
              <span className="value">{booking?.movieTitle || 'N/A'}</span>
            </div>
            <div className="summary-item">
              <span className="label">Cinema:</span>
              <span className="value">{booking?.cinemaName || 'N/A'}</span>
            </div>
            <div className="summary-item">
              <span className="label">Show Date & Time:</span>
              <span className="value">{dateTime.date} at {dateTime.time}</span>
            </div>
            <div className="summary-item">
              <span className="label">Seats:</span>
              <span className="value">{seatList || `${booking?.seatCount || 0} seat(s)`}</span>
            </div>
            <div className="summary-item">
              <span className="label">Amount:</span>
              <span className="value">₹{parseFloat(booking?.totalAmount || 0).toFixed(2)}</span>
            </div>
          </div>

          <div className="refund-info-box">
            <i className="fas fa-info-circle"></i>
            <div>
              <strong>Refund Information</strong>
              <p>
  Your refund will be processed to your original payment method within 
  <strong> {refundProcessingDays || 7} working days</strong>.
</p>
<p>
      Refer Cancellation Policy for more details.
    </p>
            </div>
          </div>

        </div>

        <div className="cancellation-modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={confirming}>
            Keep Booking
          </button>
          <button 
            className="btn-primary btn-danger" 
            onClick={handleConfirm}
            disabled={confirming}
          >
            {confirming ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Cancelling...
              </>
            ) : (
              <>
                <i className="fas fa-times"></i> Confirm Cancellation
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancellationModal;

